import get from 'lodash/get'
import { default as deserialize, formatMeta } from 'app/utils/deserialize'
import { fetch } from 'app/utils/data'
import { buildFilters } from './utils'

export default {
  namespaced: true,

  state: {
    list: [],
    item: {
      license: {},
      account: {},
      total: {}
    },
    pagination: {}
  },

  getters: {
    currentLicenses: (state) => state.list,
    currentLicense: (state) => state.item,
    currentPagination: (state) => state.pagination
  },

  mutations: {
    licensesFetched(state, { licenses }) {
      state.list = licenses
    },

    licenseFetched(state, { license }) {
      state.item = license
    },

    paginationFetched(state, { pagination }) {
      state.pagination = pagination
    }
  },

  actions: {
    async fetchLicenses({ commit }, { page = 1, filters = {} }) {
      const response = await fetch({
        url: '/api/admin/licenses',
        params: {
          page,
          ...buildFilters(filters)
        }
      })

      const licenses = await deserialize(response.data)
      const pagination = formatMeta(get(response.data, 'meta', {}))

      commit('licensesFetched', { licenses })
      commit('paginationFetched', { pagination })
    },

    async fetchLicense({ commit }, licenseId) {
      const response = await fetch({ url: `/api/admin/licenses/${licenseId}` })
      const license = await deserialize(response.data)

      commit('licenseFetched', { license })
    }
  }
}
